module.exports = __webpack_public_path__ + "static/media/3y6mlh.b10a058a.gif";